<div class="row header p-2 border-bottom">
  <!-- Date time -->
  <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-3 p-2">
    <div class="row">
      <div class="col-md-12 text-center">
        <span class="text-secondary fw-bold">{{ currentDate | date: 'HH:mm' }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 text-center">
        <span class="text-secondary">{{ currentDate | date: 'dd/MM/yyyy' }}</span>
      </div>
    </div>
  </div>

  <!-- Title -->
  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-5 col-5">
    <h4 class="text-secondary mt-3 ps-5 border-start" id="pageTitle">{{ pageTitle }}</h4>
  </div>

  <!-- Logo Insertis -->
  <div class="col-xl-2 col-lg-2 col-md-2 col-sm-4 col-4 d-flex align-items-center">
    <img class="logo" src="assets/logo-insertis.svg" role="presentation" [ngbTooltip]="version" alt="logo insertis" />
  </div>

  <!-- Logo Metropole -->
  <div class="col-xl-5 col-lg-4 col-md-4 text-end d-none d-md-block">
    <img class="logo" src="assets/logo.svg" role="presentation" [ngbTooltip]="version" alt="logo insertis" />
  </div>
</div>
